<template>
  <div class="stepper d-flex justify-content-between align-items-center">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step d-flex flex-column align-items-center"
      @click="$emit('onClickStep', index)"
    >
      <div class="circle" :class="{ active: currentStep === index }">
        {{ index + 1 }}
      </div>
      <div class="label mt-2">{{ step }}</div>
      <div v-if="index < steps.length - 1" class="line flex-grow-1"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.stepper {
  position: relative;
  width: 100%;
}

.step {
  flex: 1;
  position: relative;
}

.circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid #2f3c96;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  color: #2f3c96;
  font-weight: bold;
  z-index: 1;
  cursor: pointer;
}

.circle.active {
  background: #2f3c96;
  color: white;
}

.line {
  position: absolute;
  top: 17px;
  left: 50%;
  height: 2px;
  background: #2f3c96;
  width: 100%;
  transform: translateY(-50%);
  z-index: 0;
}

.label {
  font-size: 0.9rem;
  color: #2f3c96;
  text-align: center;
  white-space: nowrap;
}
</style>
